import {ISVG} from "../../common/Logo/Logo";

export interface ICricle1Props extends Pick<ISVG, "fill"> {}

export const Circle1 = ({ fill }: ICricle1Props) => {
    const _fill = fill ?? "#F3F2E9";

    return (
        <svg
            width="366"
            height="363"
            viewBox="0 0 366 363"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M175.241 0.294829C227.096 -1.7209 281.83 6.0007 319.014 42.1398C356.569 78.6391 366.462 133.352 365.984 185.675C365.51 237.435 354.443 291.432 316.413 326.614C279.409 360.847 225.587 365.357 175.241 362.135C128.612 359.15 83.962 342.772 51.0804 309.63C18.3562 276.647 1.76274 232.072 0.165787 185.675C-1.49424 137.446 9.08361 88.0107 42.2439 52.8985C76.2503 16.8903 125.707 2.22032 175.241 0.294829Z"
                fill={_fill}
            />
        </svg>
    );
};
